import g1 from './flowers/1.png';
import g2 from './flowers/2.png';
import g3 from './flowers/3.png';
import g4 from './flowers/4.png';
import g5 from './flowers/5.png';
import g6 from './flowers/6.png';
import g7 from './flowers/7.png';
import g8 from './flowers/8.png';
import g9 from './flowers/9.png';
import g10 from './flowers/10.png';
import g11 from './flowers/11.png';
import g12 from './flowers/12.png';

let gifts = [
  { url: g1, name: 'toy_1', rusname: 'Цветок' },
  { url: g2, name: 'toy_2', rusname: 'Цветок' },
  { url: g3, name: 'toy_3', rusname: 'Цветок' },
  { url: g4, name: 'toy_4', rusname: 'Цветок' },
  { url: g5, name: 'toy_5', rusname: 'Лепесток' },
  { url: g6, name: 'toy_6', rusname: 'Лепесток' },
  { url: g7, name: 'toy_7', rusname: 'Бутон' },
  { url: g8, name: 'toy_8', rusname: 'Бутон' },
  { url: g9, name: 'toy_9', rusname: 'Бутон' },
  { url: g10, name: 'toy_10', rusname: 'Бутон' },
  { url: g11, name: 'toy_11', rusname: 'Бутон' },
  { url: g12, name: 'toy_12', rusname: 'Бутон' },
];
export default gifts;



// WEBPACK FOOTER //
// ./src/img/gifts/gifts.js